<template>
	<v-tooltip top color="black" :disabled="!fornecedorSelecionado">
		<template #activator="{ on }">
			<v-autocomplete
				v-on="on"
				:id="`item-aditivo-apostila-${itemAditivoApostila.id}-novo-detentor`"
				v-model="fornecedorSelecionado"
				:items="listaFornecedores"
				@change="alterarFornecedor"
				placeholder="Selecione"
				class="ma-0 py-0 pt-3 mt-1"
				item-value="id"
				item-text="nomeFornecedor"
				dense
				clearable
				:disabled="disabled"
			></v-autocomplete>
		</template>
		<span>{{ nomeFornecedorAtual }}</span>
	</v-tooltip>
</template>
<script>
import { actionTypes } from '@/core/constants'
import { mapState } from 'vuex'

export default {
	name: 'alterar-detentor-item-aditivo-apostila',
	props: {
		itemSelecionado: {
			type: Object,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			itemAditivoApostila: this.itemSelecionado,
			fornecedorSelecionado: this.itemSelecionado.novoFornec,
			listaFornecedores: [],
		}
	},
	computed: {
		...mapState({
			aditivoApostila: (state) => state.aditivoApostila,
		}),
		nomeFornecedorAtual: {
			get() {
				const fornecedor = this.listaFornecedores.find(
					(fornecedor) => fornecedor.id === this.fornecedorSelecionado,
				)
				return fornecedor ? fornecedor.nomeFornecedor : ''
			},
		},
	},
	async created() {
		await this.buscarFornecedoresItemAditivoApostila()
	},
	methods: {
		async buscarFornecedoresItemAditivoApostila() {
			this.listaFornecedores = await this.$store.dispatch(
				actionTypes.ITEM_ADITIVO_APOSTILA.BUSCAR_FORNECEDORES_ITEM_ADITIVO_APOSTILA,
				this.itemAditivoApostila.id,
			)
		},
		async alterarFornecedor() {
			const { marca, valorUnitario } = await this.$store.dispatch(
				actionTypes.ITEM_ADITIVO_APOSTILA.ALTERAR_FORNECEDOR_ITEM_ADITIVO_APOSTILA,
				{
					idItemAditivoApostila: this.itemAditivoApostila.id,
					idFornecedor: this.fornecedorSelecionado,
				},
			)

			this.itemAditivoApostila.itemAta.fornecedor.marca = marca
			this.itemAditivoApostila.itemAta.valorUnitario = valorUnitario
		},
	},
}
</script>
